import { cn } from "@/lib/utils";
import { EVENT_TYPE_LABELS, EVENT_TYPE_COLORS, type CalendarEventType } from "@cold-crew/shared";

interface EventoTipoBadgeProps {
  tipo:       CalendarEventType;
  className?: string;
}

export function EventoTipoBadge({ tipo, className }: EventoTipoBadgeProps) {
  return (
    <span className={cn(
      "inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium",
      EVENT_TYPE_COLORS[tipo],
      className
    )}>
      {EVENT_TYPE_LABELS[tipo]}
    </span>
  );
}
